import { Box, Stack, Typography, useTheme } from '@mui/material';
import Link from '@mui/material/Link';
import Iconify from '@/app/components/iconify';
import { bgGradient } from '@/app/theme/css';
import { useAppSettingsContext } from '@/app/components/contexts/app-settings-context';
import { RouterLink } from '@/app/components/router-link/router-link';

export default function DirectContact() {
  const theme = useTheme();
  const { settings } = useAppSettingsContext();

  const contactSettings = Array.isArray(settings)
    ? settings.find(item => item.key === 'contact-setting')
    : undefined;

  // const contactSettings = {
  //   "_id": "67daf7ae4206f0eec48be9bb",
  //   "key": "contact-setting",
  //   "value": [
  //     {
  //       "type": "Email",
  //       "contact_link": "mailto:xciptvsmartplayer@gmail.com",
  //       "contact_id": "xciptvsmartplayer@gmail.com",
  //       "icon_name": "fluent:mail-24-regular"
  //     },
  //     {
  //       "type": "Telegram",
  //       "contact_link": "https://t.me/xciptvsmartplayer",
  //       "contact_id": "@xciptvsmartplayer",
  //       "icon_name": "ic:round-telegram"
  //     },
  //     {
  //       "type": "WhatsApp",
  //       "contact_link": "https://api.whatsapp.com/send/?phone=14435525123",
  //       "contact_id": "+14435525123",
  //       "icon_name": "ic:baseline-whatsapp"
  //     },
  //     {
  //       "type": "Viber",
  //       "contact_link": "viber://chat?number=14435525123",
  //       "contact_id": "+14435525123",
  //       "icon_name": "basil:viber-solid"
  //     }
  //   ],
  //   "__v": 5,
  //   "updatedAt": "2025-05-05T15:55:59.223Z"
  // }

  return (
    <Stack gap={4}>
      {contactSettings?.value.map((item, index) => (
        <Stack flexDirection="row" gap={3} alignItems="center" key={index}>
          <Box
            sx={{
              width: 50,
              height: 50,
              ...bgGradient({
                startColor: theme.palette.primary.main,
                endColor: theme.palette.primary.dark,
              }),
              borderRadius: 25,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Iconify icon={item.icon_name} width={30} color={theme.palette.common.white} />
          </Box>
          <Link href={item.contact_link} component={RouterLink}>
            <Stack gap={1}>
              <Typography variant="h4" color={theme.palette.text.primary}>
                {item.type}
              </Typography>
              <Typography color={theme.palette.text.primary} variant="subtitle1">
                {item.contact_id}
              </Typography>
            </Stack>
          </Link>
        </Stack>
      ))}
    </Stack>
  );
}
